import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
} from '@material-ui/core'
import { ReactNode } from 'react'
import Message from '../Message/Message'

interface Props {
  name: string
  label?: string
  bindValue: object
  error?: string
  rows?: number
  className?: string
  endAdornment?: boolean
  handleClick?: (e: React.SyntheticEvent) => void
  icon?: ReactNode
  disabled?: boolean
  autoComplete?: string
  type?: string
  onFocus?: () => void
  onBlur?: () => void
  fullWidth?: boolean
}

const TextAreaInput = ({
  name,
  label,
  bindValue,
  error,
  rows,
  className,
  endAdornment,
  handleClick,
  icon,
  disabled,
  ...restProps
}: Props) => {
  return (
    <div className={error ? 'error' : ''}>
      <label htmlFor={name} style={{ marginBottom: '0.5rem' }}>
        {label}
      </label>
      <FormControl className={`textarea ${className}`}>
        <Input
          type="text"
          name={name}
          disableUnderline={true}
          {...bindValue}
          multiline
          minRows={rows}
          maxRows={rows}
          endAdornment={
            endAdornment && (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClick}
                  disabled={disabled}
                  style={{ background: 'rgba(255,255,255,.75)' }}
                >
                  {icon}
                </IconButton>
              </InputAdornment>
            )
          }
          {...restProps}
        />
      </FormControl>
      {error !== '' && <Message variant="danger">{error}</Message>}
    </div>
  )
}

export default TextAreaInput
